import { useEffect } from 'react';

import styled from '@emotion/styled';

import StartsCard from '../../../components/Cards/StartsCard';
import TrendDownIcon from '../../../components/Icons/TrendDownIcon';
import TrendUpIcon from '../../../components/Icons/TrendUpIcon';
import useDashboardStats from '../../../hooks/dashboard/dashboard/useDashboardStats';
import { useAppSelector } from '../../../redux/store';

const DashboardStats = () => {
  const { getDashboardStats } = useDashboardStats();
  const dashboardStatsData = useAppSelector(
    (state) => state.dashboardStatsData.dashboardStatsData,
  );

  const totalDrivers = dashboardStatsData?.totalDrivers ?? 0;
  const totalVehicles = dashboardStatsData?.totalVehicles ?? 0;
  const totalAssignedDrivers = dashboardStatsData?.totalAssignedDrivers ?? 0;
  const exceedRate = dashboardStatsData?.exceedRate ?? 0;
  const totalAssignedDriversChangePercentage =
    dashboardStatsData?.totalAssignedDriversChangePercentage ?? 0;
  const totalDriversChangePercentage =
    dashboardStatsData?.totalDriversChangePercentage ?? 0;
  const totalVehiclesChangePercentage =
    dashboardStatsData?.totalVehiclesChangePercentage ?? 0;

  useEffect(() => {
    getDashboardStats();
    // eslint-disable-next-line
  }, []);

  return (
    <StatsArea>
      <StartsCard.Root>
        <StartsCard.Header>TOTAL DRIVERS</StartsCard.Header>
        <StartsCard.Value>{totalDrivers}</StartsCard.Value>
        <StartsCard.DynamicFooter trend={totalDriversChangePercentage}>
          {totalDriversChangePercentage >= 0 ? <span>↑</span> : <span>↓</span>}{' '}
          {totalDriversChangePercentage >= 0
            ? `+${totalDriversChangePercentage}%`
            : `-${Math.abs(totalDriversChangePercentage)}%`}{' '}
          from last month
        </StartsCard.DynamicFooter>
      </StartsCard.Root>

      <StartsCard.Root>
        <StartsCard.Header>TOTAL VEHICLES</StartsCard.Header>
        <StartsCard.Value>{totalVehicles}</StartsCard.Value>
        <StartsCard.DynamicFooter trend={totalVehiclesChangePercentage}>
          {totalVehiclesChangePercentage >= 0 ? <span>↑</span> : <span>↓</span>}{' '}
          {totalVehiclesChangePercentage >= 0
            ? `+${totalVehiclesChangePercentage}%`
            : `-${Math.abs(totalVehiclesChangePercentage)}%`}{' '}
          from last month
        </StartsCard.DynamicFooter>
      </StartsCard.Root>

      <StartsCard.Root>
        <StartsCard.Header>ASSIGNED DRIVERS</StartsCard.Header>
        <StartsCard.Value>{totalAssignedDrivers}</StartsCard.Value>
        <StartsCard.DynamicFooter trend={totalAssignedDriversChangePercentage}>
          {totalAssignedDriversChangePercentage >= 0 ? (
            <span>↑</span>
          ) : (
            <span>↓</span>
          )}{' '}
          {totalAssignedDriversChangePercentage >= 0
            ? `+${totalAssignedDriversChangePercentage}%`
            : `-${Math.abs(totalAssignedDriversChangePercentage)}%`}{' '}
          from last month
        </StartsCard.DynamicFooter>
      </StartsCard.Root>

      <StartsCard.Root>
        <StartsCard.Header>EXCEED RATE</StartsCard.Header>
        <StartsCard.DynamicValue trend={exceedRate}>
          <span>{exceedRate >= 0 ? <TrendUpIcon /> : <TrendDownIcon />}</span>
          <span>{Math.abs(exceedRate)}%</span>
        </StartsCard.DynamicValue>
        {exceedRate > 0 && (
          <StartsCard.PlainFooter>
            Exceeding Baseline Performance
          </StartsCard.PlainFooter>
        )}
      </StartsCard.Root>
    </StatsArea>
  );
};

export default DashboardStats;

const StatsArea = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 28px;

  @media (max-width: 884px) {
    grid-template-columns: 1fr;
  }
`;
